export default __webpack_public_path__ + "static/media/Precos_das_Filmagens_em_Vias.5f1b1227.pdf";